module.exports = __webpack_public_path__ + "static/dieter-a0080c260c97833c64d5a1d0805860f5.jpg";